import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileBlockComponent } from './mobile-block.component';

@NgModule({
  declarations: [MobileBlockComponent],
  imports: [
    CommonModule,
  ],
  exports: [MobileBlockComponent],
})
export class MobileBlockModule { }
